import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Datas from '../../../data/service/service-box.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "../../styles/serviceBox.js";
import { withTranslation } from 'react-i18next';

class ServiceBox extends Component {
    render() {
        const { t } = this.props;
        return (
            <Styles>
                {/* Service Box */}
                <section className="service-area">
                    <Container>
                        <Row>
                            <Col md="12">
                                <div className="sec-title text-center">
                                    <h4>{t('home.services.title')}</h4>
                                </div>
                            </Col>
                            {
                                Datas.dataList.map((data, i) => (
                                    <Col md="6" key={i}>
                                        <div className="service-box d-flex">
                                            <div className="box-icon">
                                                <i className={data.boxIcon}></i>
                                            </div>
                                            <Link to={process.env.PUBLIC_URL + data.serviceLink}>
                                                <div className="box-title">
                                                    <h5>{t(`home.services.list.${i}.title`)}</h5>
                                                    <p>{t(`home.services.list.${i}.subtitle`)}</p>
                                                </div>
                                            </Link>
                                        </div>
                                    </Col>
                                ))
                            }
                        </Row>
                    </Container>
                </section>
            </Styles>
        )
    }
}

export default withTranslation()(ServiceBox)